import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});



export const articleService = {
  getAll: async () => await api.get('/articles'),
  getForManagement: async () => await api.get('/articles', { params: { includeUnpublished: true } }),
  getById: async (id) => await api.get(`/articles/${id}`),
  create: async (data) => await api.post('/articles', data),
  update: async (id, data) => await api.put(`/articles/${id}`, data),
  updateStatus: async (id, status) => await api.put(`/articles/${id}/status`, { status }),
  updateFeatured: async (id, isFeatured) => await api.put(`/articles/${id}/featured`, { isFeatured }),
  delete: async (id) => await api.delete(`/articles/${id}`),
  getByStatus: async (status) => await api.get(`/articles/status/${status}`),
};

export const issueService = {
  getAll: async () => await api.get('/issues'),
  getForManagement: async () => await api.get('/issues', { params: { includeUnpublished: true } }),
  getById: async (id) => await api.get(`/issues/${id}`),
  create: async (data) => await api.post('/issues', data),
  update: async (id, data) => await api.put(`/issues/${id}`, data),
  delete: async (id) => await api.delete(`/issues/${id}`),
};

export const authorService = {
  getAll: async () => await api.get('/authors'),
  getById: async (id) => await api.get(`/authors/${id}`),
  create: async (data) => await api.post('/authors', data),
  update: async (id, data) => await api.put(`/authors/${id}`, data),
  delete: async (id) => await api.delete(`/authors/${id}`),
};

export const reviewService = {
  getAll: async () => await api.get('/reviews'),
  getById: async (id) => await api.get(`/reviews/${id}`),
  create: async (data) => await api.post('/reviews', data),
  getByArticle: async (articleId) => await api.get(`/reviews/article/${articleId}`),
  getByReviewer: async (reviewerId) => await api.get(`/reviews/reviewer/${reviewerId}`),
};

export const legalFrameworkService = {
  get: async () => await api.get('/legalframework'),
  create: async (data) => await api.post('/legalframework', data),
  update: async (id, data) => await api.put(`/legalframework/${id}`, data),
  delete: async (id) => await api.delete(`/legalframework/${id}`),
};

export const aboutService = {
  get: async () => await api.get('/about'),
  create: async (data) => await api.post('/about', data),
  update: async (id, data) => await api.put(`/about/${id}`, data),
  delete: async (id) => await api.delete(`/about/${id}`),
};

export const policyService = {
  getAll: async () => await api.get('/policy'),
  create: async (data) => await api.post('/policy', data),
  update: async (id, data) => await api.put(`/policy/${id}`, data),
  delete: async (id) => await api.delete(`/policy/${id}`),
};

export const ethicsReviewService = {
  get: async () => await api.get('/ethicsreview'),
  create: async (data) => await api.post('/ethicsreview', data),
  update: async (id, data) => await api.put(`/ethicsreview/${id}`, data),
  delete: async (id) => await api.delete(`/ethicsreview/${id}`),
};

export const publicationTermsService = {
  get: async () => await api.get('/publicationterms'),
  create: async (data) => await api.post('/publicationterms', data),
  update: async (id, data) => await api.put(`/publicationterms/${id}`, data),
  delete: async (id) => await api.delete(`/publicationterms/${id}`),
};

export const scopeObjectivesService = {
  get: async () => await api.get('/scopeobjectives'),
  create: async (data) => await api.post('/scopeobjectives', data),
  update: async (id, data) => await api.put(`/scopeobjectives/${id}`, data),
  delete: async (id) => await api.delete(`/scopeobjectives/${id}`),
};

export const historyService = {
  get: async () => await api.get('/history'),
  create: async (data) => await api.post('/history', data),
  update: async (id, data) => await api.put(`/history/${id}`, data),
  delete: async (id) => await api.delete(`/history/${id}`),
};

export const templateService = {
  getAll: async () => await api.get('/templates'),
  create: async (data) => await api.post('/templates', data),
  update: async (id, data) => await api.put(`/templates/${id}`, data),
  delete: async (id) => await api.delete(`/templates/${id}`),
};

export const newsletterService = {
  get: async () => await api.get('/newsletters'),
  create: async (data) => await api.post('/newsletters', data),
  update: async (id, data) => await api.put(`/newsletters/${id}`, data),
  delete: async (id) => await api.delete(`/newsletters/${id}`),
};

export const rssFeedService = {
  get: async () => await api.get('/rssfeeds'),
  create: async (data) => await api.post('/rssfeeds', data),
  update: async (id, data) => await api.put(`/rssfeeds/${id}`, data),
  delete: async (id) => await api.delete(`/rssfeeds/${id}`),
};

export const relatedJournalsService = {
  getAll: async () => await api.get('/relatedjournals'),
  create: async (data) => await api.post('/relatedjournals', data),
  update: async (id, data) => await api.put(`/relatedjournals/${id}`, data),
  delete: async (id) => await api.delete(`/relatedjournals/${id}`),
};

export const feedbackService = {
  getAll: async () => await api.get('/feedbacks'),
  create: async (data) => await api.post('/feedbacks', data),
  delete: async (id) => await api.delete(`/feedbacks/${id}`),
};

export const sitemapLinkService = {
  getAll: async () => await api.get('/sitemaplinks'),
  create: async (data) => await api.post('/sitemaplinks', data),
  update: async (id, data) => await api.put(`/sitemaplinks/${id}`, data),
  delete: async (id) => await api.delete(`/sitemaplinks/${id}`),
};

export const forAuthorsService = {
  get: async () => await api.get('/forauthorscontents'),
  create: async (data) => await api.post('/forauthorscontents', data),
  update: async (id, data) => await api.put(`/forauthorscontents/${id}`, data),
};

export const submissionProcessService = {
  get: async () => await api.get('/submissionprocesses'),
  create: async (data) => await api.post('/submissionprocesses', data),
  update: async (id, data) => await api.put(`/submissionprocesses/${id}`, data),
};

export const contactInfoService = {
  get: async () => await api.get('/contactinfos'),
  create: async (data) => await api.post('/contactinfos', data),
  update: async (id, data) => await api.put(`/contactinfos/${id}`, data),
};

export const journalFeatureService = {
  getAll: async () => await api.get('/journalfeatures'),
  create: async (data) => await api.post('/journalfeatures', data),
  update: async (id, data) => await api.put(`/journalfeatures/${id}`, data),
  delete: async (id) => await api.delete(`/journalfeatures/${id}`),
};

export const siteContentService = {
  get: async (key) => await api.get(`/sitecontents/${encodeURIComponent(key)}`),
  set: async (key, data) => await api.post(`/sitecontents/${encodeURIComponent(key)}`, data),
};

export const uploadService = {
  uploadSlide: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const uploadApi = axios.create({
      baseURL: API_BASE_URL,
      withCredentials: true,
    });
    return await uploadApi.post('/uploads/slide', formData);
  },
};

export const openAccessService = {
  get: async () => await api.get('/openaccess'),
  create: async (data) => await api.post('/openaccess', data),
  update: async (id, data) => await api.put(`/openaccess/${id}`, data),
  delete: async (id) => await api.delete(`/openaccess/${id}`),
};

export const authService = {
  register: async (data) => await api.post('/auth/register', data),
  login: async (data) => await api.post('/auth/login', data),
  me: async () => await api.get('/auth/me'),
  logout: async () => await api.post('/auth/logout'),
};

export const userService = {
  getAll: async () => await api.get('/users'),
  getById: async (id) => await api.get(`/users/${id}`),
  update: async (id, data) => await api.put(`/users/${id}`, data),
  delete: async (id) => await api.delete(`/users/${id}`),
};

export const rbacService = {
  getPermissions: async () => await api.get('/rbac/permissions'),
  getRoles: async () => await api.get('/rbac/roles'),
  getRole: async (id) => await api.get(`/rbac/roles/${id}`),
  getRolePermissions: async (id) => await api.get(`/rbac/roles/${id}/permissions`),
  setRolePermissions: async (id, permissionIds) => await api.post(`/rbac/roles/${id}/permissions`, permissionIds),
  createRole: async (data) => await api.post('/rbac/roles', data),
  deleteRole: async (id) => await api.delete(`/rbac/roles/${id}`),
  getUserRoles: async (userId) => await api.get(`/rbac/users/${userId}/roles`),
  assignRole: async (userId, roleId) => await api.post(`/rbac/users/${userId}/roles`, roleId),
  removeRole: async (userId, roleId) => await api.delete(`/rbac/users/${userId}/roles/${roleId}`),
};

const apiServices = { articleService, issueService, authorService, reviewService, legalFrameworkService, aboutService, policyService, ethicsReviewService, publicationTermsService, scopeObjectivesService, historyService, openAccessService, templateService, newsletterService, rssFeedService, relatedJournalsService, feedbackService, sitemapLinkService, forAuthorsService, submissionProcessService, contactInfoService, journalFeatureService, siteContentService, uploadService, authService, userService, rbacService };
export default apiServices;

export const reviewerService = {
  getAll: () => api.get('/reviewers'),
  getById: (id) => api.get(`/reviewers/${id}`),
  create: (data) => api.post('/reviewers', data),
  update: (id, data) => api.put(`/reviewers/${id}`, data),
  delete: (id) => api.delete(`/reviewers/${id}`),
};

export const assignmentService = {
  list: (articleId) => api.get('/reviewerassignments', { params: { articleId } }),
  assign: (data) => api.post('/reviewerassignments', data),
  reassign: (id, data) => api.post(`/reviewerassignments/${id}/reassign`, data),
  withdraw: (id, data) => api.post(`/reviewerassignments/${id}/withdraw`, data),
  mine: () => api.get('/reviewerassignments/mine'),
  submission: (id) => api.get(`/reviewerassignments/mine/${id}`),
  account: (id) => api.get(`/reviewers/${id}/account`),
  linkAccount: (id, data) => api.put(`/reviewers/${id}/account`, data),
  availability: (id, data) => api.put(`/reviewers/${id}/availability`, data),
};
